import React from 'react';
import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import { ReactComponent as Checked } from 'assets/icons/circle-check.svg';
import { ReactComponent as NotChecked } from 'assets/icons/close.svg';
import { useTranslation } from 'localization';

import BorderedBox from '../../../ProfileTab/components/BorderedBox';

const rowBorder = 'rgba(255,255,255,0.06)';

const LevelFeatures: React.FC<{
  levelManagement: {
    title: string;
    steps: {
      0: { color: string; icon: any };
      1: { color: string; icon: any };
      2: { color: string; icon: any };
      3: { color: string; icon: any };
    };
    features: { title: string; isActive: boolean; description: string }[];
  };
}> = ({ levelManagement }) => {
  const { t } = useTranslation('component.settings.verification');
  const { features, title } = levelManagement;
  const sectionTitle = `${t('capabilitiesTitle')}: ${title}`;

  return (
    <BorderedBox title={sectionTitle} w={{ base: '100%', xl: '50%' }} minW={0}>
      {features.length === 0 ? (
        <Text fontSize="sm" color="body2" py={1}>
          {t('noFeatures')}
        </Text>
      ) : (
        <Stack gap={0}>
          {features.map((item, index) => (
            <Stack
              key={item.title}
              gap={0}
              py={3}
              borderBottomWidth={index < features.length - 1 ? '1px' : 0}
              borderBottomColor={rowBorder}
            >
              <HStack
                w="100%"
                alignItems="flex-start"
                justifyContent="space-between"
                gap={3}
              >
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  color="body"
                  wordBreak="break-word"
                >
                  {item.title}
                </Text>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  w={5}
                  flexShrink={0}
                  pt={0.5}
                >
                  {item.isActive ? <Checked /> : <NotChecked />}
                </Box>
              </HStack>
              {item.description ? (
                <Text
                  fontSize="sm"
                  color="body2"
                  textAlign="left"
                  mt={1}
                  wordBreak="break-word"
                >
                  {item.description}
                </Text>
              ) : null}
            </Stack>
          ))}
        </Stack>
      )}
    </BorderedBox>
  );
};

export default LevelFeatures;
